import Marquee from "react-fast-marquee";
import { useLang } from "@/contexts/LanguageContext";
import { useT } from "@/lib/i18n";
import { HOME } from "@/constants/testIds";

const EditorialMarquee = () => {
    const { lang } = useLang();
    const t = useT(lang);
    const items = t("marquee");

    return (
        <section
            data-testid={HOME.marquee}
            className="relative border-y overflow-hidden"
            style={{ background: "var(--bg-secondary)", borderColor: "rgba(232,58,116,0.15)" }}
        >
            <Marquee speed={38} gradient={false} pauseOnHover>
                {items.concat(items).map((item, i) => (
                    <span key={i} className="marquee-item text-4xl md:text-6xl px-12 md:px-16 py-8 md:py-10">
                        <span>{item}</span>
                        <span className="marquee-dot ml-12 md:ml-16">✦</span>
                    </span>
                ))}
            </Marquee>
        </section>
    );
};

export default EditorialMarquee;
